/** Shared target amount parsing for QuickTest (operating-currency units). */

export function parseTargetChf(raw) {
  const trimmed = String(raw ?? '').trim();
  if (!trimmed) {
    return { value: 0, error: '' };
  }
  if (/[^0-9'’\s,]/.test(trimmed)) {
    return { value: null, error: 'Enter a numeric amount' };
  }
  const digits = trimmed.replace(/[^0-9]/g, '');
  if (!digits) {
    return { value: null, error: 'Enter a numeric amount' };
  }
  return { value: parseInt(digits, 10) || 0, error: '' };
}
